import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import uuid from "uuid";
import PDF from "react-pdf-js";
import Dialog from "material-ui/Dialog";
import CircularProgress from "material-ui/CircularProgress";
import { StyledButton } from "components/support";

class DocumentViewer extends PureComponent {
  static propTypes = {
    data: PropTypes.any,
    documentName: PropTypes.any,
    onHide: PropTypes.any,
    visible: PropTypes.any,
    title: PropTypes.any
  };

  constructor(props) {
    super(props);
    this.state = {
      frameIdentifier: `document-viewer-${uuid()}`
    };
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const file = new Blob([nextProps.data], { type: "application/pdf" });
    const fileURL = window.URL.createObjectURL(file);

    this.setState(
      () => ({
        documentUrl: fileURL,
        documentBlob: nextProps.data
      }),
      this.contentReloaded
    );
  }

  contentReloaded = () => {
    setTimeout(() => window.dispatchEvent(new Event("resize")), 0);
  };

  disabled = () => !this.props.data || this.props.data.length === 0;

  pdfLoader = <CircularProgress size={80} thickness={5} />;

  hiddenElements = () => (
    <div style={{ display: "none" }}>
      <a
        ref={a => {
          this.downloadButton = a;
        }}
        href={this.state.documentUrl}
        download={this.props.documentName}
      >
        &nbsp;
      </a>
      <iframe
        src={this.state.documentUrl}
        name={this.state.frameIdentifier}
        id={this.state.frameIdentifier}
        title={this.state.frameIdentifier}
      />
    </div>
  );

  documentPdf = () => {
    if (this.state.documentBlob) {
      return (
        <PDF
          scale={2}
          binaryContent={{ data: this.state.documentBlob }}
          loading={this.pdfLoader}
        />
      );
    }

    return this.pdfLoader;
  };

  downloadDocument = () => {
    if (!this.disabled()) {
      this.downloadButton.click();
    }
  };

  printDocument = () => {
    if (!this.disabled()) {
      window.frames[this.state.frameIdentifier].print();
    }
  };

  actions = () => [
    <StyledButton onTouchTap={this.props.onHide}>Voltar</StyledButton>,
    <StyledButton
      disabled={this.disabled()}
      onTouchTap={() => this.downloadDocument()}
    >
      Download
    </StyledButton>,
    <StyledButton
      disabled={this.disabled()}
      onTouchTap={() => this.printDocument()}
      primary
    >
      Imprimir
    </StyledButton>
  ];

  render() {
    return (
      <Dialog
        title={this.props.title}
        actions={this.actions()}
        modal={false}
        open={this.props.visible}
        onRequestClose={this.props.onHide}
        autoScrollBodyContent={true}
        bodyStyle={{
          background: "#333",
          padding: "24px 0",
          textAlign: "center"
        }}
        contentStyle={{ width: "95%", maxWidth: "none" }}
      >
        {this.hiddenElements()}
        {this.documentPdf()}
      </Dialog>
    );
  }
}

export default DocumentViewer;



// WEBPACK FOOTER //
// ./src/components/support/document-viewer/index.jsx